export interface cv_Compliance {
    C_Compliance_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    Compliance: string;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    IsEndStatus: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
